module.exports = __webpack_public_path__ + "static/media/1569521939426-1850793713.172e031b.jpg";